"use client";

import { forwardRef } from "react";
import clsx from "clsx";
import { motion, useReducedMotion } from "framer-motion";
import type { SiteNavItem } from "./navigation.utils";
import styles from "./navigation.module.css";

type NavItemProps = {
  item: SiteNavItem;
  active?: boolean;
  onSelect: (event: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
};

export const NavItem = forwardRef<HTMLAnchorElement, NavItemProps>(
  function NavItem({ item, active = false, onSelect }, ref) {
    const prefersReducedMotion = useReducedMotion();

    return (
      <motion.a
        ref={ref}
        href={item.href}
        className={clsx(styles.navItem, active && styles.navItemActive)}
        aria-current={active ? "location" : undefined}
        onClick={(event) => onSelect(event, item.href)}
        whileHover={prefersReducedMotion ? undefined : { y: -1, scale: 1.015 }}
        whileTap={prefersReducedMotion ? undefined : { scale: 0.985 }}
        transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
      >
        {item.label}
      </motion.a>
    );
  }
);

